<template>
    <div class="main-div">
        <div class="header-div">
            <div class="icon-div">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="380"
                    height="380"
                    viewBox="0 0 480 480"
                    fill="none"
                    class="pattern"
                    opacity="0.4"
                >
                    <defs>
                        <clipPath id="clip-circle">
                            <rect x="190" y="190" width="240" height="240" />
                        </clipPath>
                    </defs>
                    <g clip-path="url(#clip-circle)">
                        <circle cx="240" cy="240" r="47.5" stroke="#E4E4E7" />
                        <circle cx="240" cy="240" r="79.5" stroke="#E4E4E7" />
                        <circle cx="240" cy="240" r="111.5" stroke="#E4E4E7" />
                        <circle cx="240" cy="240" r="143.5" stroke="#E4E4E7" />
                    </g>
                </svg>

                <svg class="icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path
                        d="M16 6V5.2C16 4.0799 16 3.51984 15.782 3.09202C15.5903 2.71569 15.2843 2.40973 14.908 2.21799C14.4802 2 13.9201 2 12.8 2H11.2C10.0799 2 9.51984 2 9.09202 2.21799C8.71569 2.40973 8.40973 2.71569 8.21799 3.09202C8 3.51984 8 4.0799 8 5.2V6M10 11.5V16.5M14 11.5V16.5M3 6H21M19 6V17.2C19 18.8802 19 19.7202 18.673 20.362C18.3854 20.9265 17.9265 21.3854 17.362 21.673C16.7202 22 15.8802 22 14.2 22H9.8C8.11984 22 7.27976 22 6.63803 21.673C6.07354 21.3854 5.6146 20.9265 5.32698 20.362C5 19.7202 5 18.8802 5 17.2V6"
                        stroke="#D92D20"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </svg>
            </div>
            <div class="title-wrapper">
                <div class="flex flex-col justify-between self-stretch">
                    <span>Remove Item</span>
                    <p>
                        Removing this item from your Identity Vault will cause it to become suppressed and we'll no longer scan the
                        web for it.
                    </p>
                    <div class="item-remove">
                        <h2>Email:</h2>
                        johndoe@email.com
                    </div>
                </div>
                <!-- <svg
                    @click="closeDialog"
                    class="cursor-pointer"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                >
                    <path
                        d="M18 6L6 18M6 6L18 18"
                        stroke="#A4A7AE"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </svg> -->
            </div>
        </div>
        <div class="footer-div">
            <div class="footer-actions">
                <PrimeButton @click="closeDialog" label="Cancel" variant="secondary" class="p-btn-root_secondary" />
                <PrimeButton label="Remove" variant="error" />
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
import { ModalNames } from '~/types/modals';

const dialogRef =   getDialogRef(ModalNames.REMOVE_FROM_VAULT);
const closeDialog = () => {
    dialogRef.value.close();
};
</script>
<style lang="scss" scoped>
.main-div {
    @apply sm:max-w-xl w-11/12 rounded-lg bg-white mx-auto flex flex-col items-center self-stretch shadow-cardshadow ;
}
.header-div {
    @apply flex items-start gap-4 p-6 self-stretch;
    .icon-div {
        @apply flex justify-center items-center flex-col gap-8 relative p-2 rounded-full border-8 border-error-50 bg-error-200;

        .pattern {
            @apply absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none;
        }
        .icon {
            @apply absolute -top-4 w-14 h-14 p-2 rounded-full border-8 border-error-50 bg-error-200;
        }
    }

    .title-wrapper {
        @apply flex flex-row items-start gap-1 sm:flex-1 sm:w-auto w-full;

        span {
            @apply text-gray-900 font-inter text-lg not-italic font-semibold ;
        }

        p {
            @apply text-gray-600 font-inter text-sm not-italic font-normal ;
        }
    }
}
.item-remove {
    @apply flex flex-row gap-1 mt-4 text-gray-600 font-inter text-sm not-italic font-normal ;
    h2 {
        @apply text-gray-600 font-inter text-sm not-italic font-medium ;
    }
}
.footer-div {
    @apply flex pt-8 flex-col items-end self-stretch;

    .footer-actions {
        @apply flex px-6 pb-6 justify-end items-start gap-3 self-stretch;
    }
}
</style>
